import { RootState } from '@Core/Communication'
import { useSelector } from 'react-redux'

export const usePermissions = () => {
    const { user } = useSelector((state: RootState) => state.user)
    const { isAuthenticationFinished, isLogged } = useSelector(
        (state: RootState) => state.authentication
    )

    // `user` can exist before the profile (and its roles) arrives: the photo
    // and feature-flag reducers spread into an empty user, and the token check
    // flags authentication as finished on its own. Only the profile loaded by
    // useUser.getUser carries `mail`, so wait for it before judging roles —
    // otherwise PrivacyRoute redirects to /permission-denied on a deep link.
    const loading = !isAuthenticationFinished || !user?.mail

    const hasPermission = (permission: string) => {
        if (import.meta.env.VITE_MOCK_AUTH) {
            return true
        }
        if (!isLogged) {
            return false
        }
        return user?.roles?.some((role) => role === permission) || false
    }
    const hasModulePermission = (module: string) => {
        if (import.meta.env.VITE_MOCK_AUTH) {
            return true
        }
        if (!isLogged) {
            return false
        }
        return user?.roles?.some((role) => role.startsWith(module)) || false
    }

    return {
        loading,
        hasPermission,
        hasModulePermission,
    }
}
